const DEFAULT_BRIEFING_MODE = 'news';
const DEEP_DIVE_BRIEFING_MODE = 'deepDive';
const MAX_NODE_PATH_DEPTH = 8;
const DEFAULT_NODE_LEVEL = 2;

function normalizeLotsogBriefingMode(value) {
  return value === DEEP_DIVE_BRIEFING_MODE ? DEEP_DIVE_BRIEFING_MODE : DEFAULT_BRIEFING_MODE;
}

function sanitizeLotsogSelectedNodes(selectedNodes) {
  return (Array.isArray(selectedNodes) ? selectedNodes : [])
    .map((node) => ({
      id: typeof node?.id === 'string' ? node.id.trim() : '',
      label: typeof node?.label === 'string' ? node.label.trim() : '',
      level: Number.isFinite(node?.level) ? Number(node.level) : DEFAULT_NODE_LEVEL,
      briefingMode: normalizeLotsogBriefingMode(node?.briefingMode),
      topic: typeof node?.topic === 'string' ? node.topic.trim() : '',
      locality: typeof node?.locality === 'string' ? node.locality.trim() : '',
      path: Array.isArray(node?.path)
        ? node.path
          .map((entry) => (typeof entry === 'string' ? entry.trim() : ''))
          .filter(Boolean)
          .slice(0, MAX_NODE_PATH_DEPTH)
        : [],
    }))
    .filter((node) => node.id && node.label);
}

module.exports = {
  normalizeLotsogBriefingMode,
  sanitizeLotsogSelectedNodes,
};
